export default __webpack_public_path__ + "static/factoryfix-9eba8d1730d65e3cfe9a473c808523d6.svg";